import React from 'react';
import { ViewProps } from 'react-native';
import { Container } from 'src/components';
import { AppColors, CustomShadow } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';

interface Props extends ViewProps {
  children?: any;
  flex?: number | boolean;
  backgroundColor?: string | null | undefined;
  borderRadius?: number | null | undefined;
  padding?: number;
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
  paddingVertical?: number;
  paddingHorizontal?: number | string;
  margin?: number | string;
  marginHorizontal?: number | string;
  marginVertical?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  marginTop?: number | string;
  marginBottom?: number | string;
  width?: number | string;
  height?: number | string;
}

export const CardContainer = (props: Props) => {
  const {
    style,
    flex,
    backgroundColor,
    borderRadius,
    height,
    width,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingHorizontal,
    paddingVertical,
    margin,
    marginHorizontal,
    marginVertical,
    marginBottom,
    marginTop,
    marginLeft,
    marginRight,
    children,
    padding = metrics.large,
    ...otherProps
  } = props;

  return (
    <Container
      backgroundColor={AppColors.white}
      borderRadius={metrics.borderRadius}
      style={
        [
          CustomShadow,
          {
            padding,
            paddingTop,
            paddingBottom,
            paddingLeft,
            paddingRight,
            paddingHorizontal,
            paddingVertical,
            margin,
            marginHorizontal,
            marginVertical,
            marginBottom,
            marginTop,
            marginLeft,
            marginRight,
            height,
            width,
            flex,
            backgroundColor,
            borderRadius,
          },
          style,
        ] as any
      }
      {...otherProps}>
      {children}
    </Container>
  );
};
